'use client'

import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { IconArrowLeft } from '@redteclab/icons'

import { Button } from 'base-ui'

import { useGlobalConfigContext } from '../../global-config'
import { SeoHeadTitleMetas } from '../../seo'
import { urlResolverGetOtherTopicsContactPage } from '../../url-handling'

import { DirectContactForm } from './DirectContactForm/DirectContactForm'

export const DirectContactClientPage: FC = () => {
  const config = useGlobalConfigContext()
  const intl = useIntl()
  const title = intl.formatMessage({
    id: 'help.centre.others.options.write.us',
  })
  const contactTopicsPageUrl = urlResolverGetOtherTopicsContactPage(config)

  return (
    <section
      className="bg-light-primary-low px-4 py-6 tablet:py-12"
      data-qa-id="direct-contact-page"
    >
      <SeoHeadTitleMetas title={title} />
      <div className="tablet:container">
        <div className="flex flex-col items-center gap-6 tablet:gap-12">
          <Button<'a'>
            className="self-start"
            href={contactTopicsPageUrl}
            slots={{ root: 'a' }}
            startIcon={<IconArrowLeft />}
            variant="text"
          >
            <FormattedMessage id="direct.contact.form.back.to.otherTopics" />
          </Button>
          <div className="w-full max-w-2xl rounded-m bg-light-primary-low">
            <DirectContactForm title={title} />
          </div>
        </div>
      </div>
    </section>
  )
}
